<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-fade-transition mode="out-in">
          <a-authorization-card
            v-if="transmis"
            class="ma-5"
            color="success"
            icon="mdi-check"
            title="Transmission"
            text="Votre réponse a bien été transmise."
          />
          <a-authorization-card
            v-else-if="erreur"
            class="ma-5"
            color="error"
            icon="mdi-cancel"
            title="Oups..."
            text="Aucune demande de pièces en attente ne correspond à cette URL."
          />
          <v-form ref="form" v-else-if="charge">
            <v-row>
              <v-col cols="12" class="d-flex flex-column">
                <div class="am-h2">Réponse à demande de pièces</div>

                <div class="accent-block mt-4 mb-4">
                  <template v-if="item.type === 'DEMANDE_PIECES'">
                    Merci de bien vouloir répondre aux précisions demandées ci-dessous par
                    le greffe avant le
                    <span class="primary--text">{{ item.dateRetour | date }}</span>
                    et de joindre les documents nécessaires via le bouton "ajouter" le cas
                    échéant.
                  </template>
                  <template v-if="item.type === 'AVIS_FINS_PAIEMENT'">
                    Merci de bien vouloir joindre le justificatif de paiement des frais de
                    publication fourni par le journal d'annonces légales via le bouton
                    "ajouter".
                  </template>
                  <template v-if="estDemandeObservations">
                    Merci de bien vouloir répondre aux précisions demandées ci-dessous par
                    le greffe avant le
                    <span class="primary--text">{{ item.dateRetour | date }}</span>
                    et de joindre les documents nécessaires via le bouton "ajouter".
                  </template>
                </div>
              </v-col>
            </v-row>

            <v-card>
              <a-demande-pieces-sheet
                v-model="item"
                @ajouter="ajouterDocument"
                @supprimer="supprimerDocument"
                @telecharge="telechargeDocument"
              />
              <v-card-text v-if="!estDemandeObservations">
                <v-textarea
                  label="Précisions relatives à la demande de pièces"
                  filled
                  v-model="item.observation"
                  :rules="[serverRule('observation')]"
                  persistent-hint
                  data-testid="precision-demande-pieces"
                />
              </v-card-text>
            </v-card>
            <div class="d-flex justify-center mt-1">
              <v-btn data-testid="valider-demande-piece" color="primary" @click="doValider"> Valider </v-btn>
            </div>
          </v-form>
          <v-skeleton-loader
            v-else
            loading
            type="card-heading, actions, card, sentences"
          />
        </v-fade-transition>
      </v-col>
    </v-row>
    <a-document-dialog
      ref="documents"
      typesDocuments="pieces"
      :codePostal="item.codePostal"
    />
    <a-supprime-document-dialog ref="supprime" />
    <a-demande-pieces-validation-dialog ref="validation" :working="working" />
  </v-container>
</template>

<script>
import makeRemoteWorker from "@/mixins/makeRemoteWorker";
import makeRules from "@/mixins/makeRules";
import { piecesService, documentService } from "@/services";
export default {
  mixins: [makeRemoteWorker(), makeRules({ inject: false })],
  props: {
    id: {
      type: String,
      required: true,
    },
    auth: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      charge: false,
      erreur: false,
      transmis: false,
      item: {
        observation: null,
        dateRetour: null,
        etat: null,
        type: null,
        demandes: [],
        codePostal: null,
      },
    };
  },

  mounted() {
    this.chargeDemande();
  },
  computed: {
    estDemandeObservations() {
      return this.item?.type === "OBSERVATIONS";
    },
  },
  methods: {
    doValider() {
      this.$refs.validation.ouvre(this.auth, captcha => {
        this.doWork({
          forms: [this.$refs.form, this.$refs.validation.form()],
          work() {
            return piecesService.transmettreDemandePiece(
              this.id,
              captcha,
              {
                observation: this.item.observation,
              },
              this.auth
            );
          },
          callback() {
            this.$refs.validation.ferme();
            this.transmis = true;
          },
          successText: "La réponse a été transmise",
          errorText: "Erreur durant la transmission de la réponse",
        });
      });
    },
    supprimerDocument({ document, piece }) {
      this.$refs.supprime.supprime({ document }, () => {
        const index = piece.index;
        const pieces = this.item.demandes[index].pieces;
        const sup = document.index;
        pieces.splice(sup, 1);
        this.item.demandes[index].pieces = pieces.map((p, i) => ({
          ...p,
          index: i,
        }));
      });
    },
    telechargeDocument(document) {
      documentService.telechargeBlob(document.nom, document.lien);
    },
    ajouterDocument(demande) {
      const index = demande.index;
      this.$refs.documents.nouveau(
        doc => {
          const { fichier, nom, journal, type, sousType, date, dateEffet } = doc;
          return piecesService.ajouteDocumentPiece(
            this.id,
            index,
            { nom, journal, type, sousType, date, dateEffet },
            fichier
          );
        },
        r => {
          const { requete, piece } = piecesService.extraitIdPiece(this.id);
          const pieces = this.item.demandes[index].pieces;
          pieces.push({
            ...r,
            index: pieces.length,
            lien: `/api/pieces/${requete}/${piece}/${index}/${r.uuid}/${r.nom}`,
          });
        },
        { type: demande.type }
      );
    },
    chargeDemande() {
      piecesService
        .consultationPiece(this.id)
        .then(body => {
          const { requete, piece } = piecesService.extraitIdPiece(this.id);

          this.charge = true;
          const item = this.item;
          item.observation = body.observation;
          item.dateRetour = body.dateRetour;
          item.etat = body.etat;
          item.type = body.type;
          item.demandes = body.demandes.map((d, index) => ({
            ...d,
            index,
            pieces: (d.pieces || []).map((p, i) => ({
              ...p,
              index: i,
              lien: `/api/pieces/${requete}/${piece}/${index}/${p.uuid}/${p.nom}`,
            })),
          }));
          item.codePostal = body.codePostal;
        })
        .catch(() => {
          this.erreur = true;
        });
    },
  },
};
</script>
